var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-setting-group-component p-5" }, [
    _vm.isWebinar || _vm.isRoomMode("exam")
      ? _c("div", { staticClass: "room-setting-group-disable-wrap" }, [
          _c("p", [_vm._v(_vm._s(_vm.setDisableText()))]),
        ])
      : _c("div", { staticClass: "room-setting-content-wrap" }, [
          _c("div", { staticClass: "room-setting-content-box" }, [
            _c("h6", { staticClass: "room-setting-content-title" }, [
              _vm._v(" " + _vm._s(_vm.$t("setting.group.title")) + " "),
              _vm.isRoomMode("group")
                ? _c("div", { staticClass: "group-on" }, [
                    _vm._v(_vm._s(_vm.$t("setting.group.ongoing"))),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "room-setting-content-text-box" }, [
              _c("p", { staticClass: "room-setting-content-text" }, [
                _vm._v(_vm._s(_vm.$t("setting.group.explain"))),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "room-setting-content-box" }, [
            _c("h6", { staticClass: "room-setting-content-title" }, [
              _vm._v(_vm._s(_vm.$t("setting.group.make"))),
            ]),
            _c(
              "div",
              { staticClass: "room-setting-input-box" },
              [
                _c("GrmSelect", {
                  attrs: {
                    label: _vm.$t("group.setting.amount"),
                    white: true,
                    options: [
                      {
                        value: 2,
                        title: _vm.$t("group.setting.groupCount", { 0: "2" }),
                        selected: _vm.roomGroupCount === 2,
                      },
                      {
                        value: 3,
                        title: _vm.$t("group.setting.groupCount", { 0: "3" }),
                        selected: _vm.roomGroupCount === 3,
                      },
                      {
                        value: 4,
                        title: _vm.$t("group.setting.groupCount", { 0: "4" }),
                        selected: _vm.roomGroupCount === 4,
                      },
                      {
                        value: 5,
                        title: _vm.$t("group.setting.groupCount", { 0: "5" }),
                        selected: _vm.roomGroupCount === 5,
                      },
                      {
                        value: 6,
                        title: _vm.$t("group.setting.groupCount", { 0: "6" }),
                        selected: _vm.roomGroupCount === 6,
                      },
                      {
                        value: 7,
                        title: _vm.$t("group.setting.groupCount", { 0: "7" }),
                        selected: _vm.roomGroupCount === 7,
                      },
                      {
                        value: 8,
                        title: _vm.$t("group.setting.groupCount", { 0: "8" }),
                        selected: _vm.roomGroupCount === 8,
                      },
                      {
                        value: 9,
                        title: _vm.$t("group.setting.groupCount", { 0: "9" }),
                        selected: _vm.roomGroupCount === 9,
                      },
                      {
                        value: 10,
                        title: _vm.$t("group.setting.groupCount", { 0: "10" }),
                        selected: _vm.roomGroupCount === 10,
                      },
                    ],
                  },
                  model: {
                    value: _vm.roomGroupCount,
                    callback: function ($$v) {
                      _vm.roomGroupCount = $$v
                    },
                    expression: "roomGroupCount",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "room-setting-input-box" }, [
              _c("label", { staticClass: "room-setting-label" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.showRoomGroupUserInFilmArea,
                      expression: "showRoomGroupUserInFilmArea",
                    },
                  ],
                  staticClass: "room-setting-radio",
                  attrs: { type: "checkbox", name: "useChat" },
                  domProps: {
                    checked: Array.isArray(_vm.showRoomGroupUserInFilmArea)
                      ? _vm._i(_vm.showRoomGroupUserInFilmArea, null) > -1
                      : _vm.showRoomGroupUserInFilmArea,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.showRoomGroupUserInFilmArea,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.showRoomGroupUserInFilmArea = $$a.concat([
                              $$v,
                            ]))
                        } else {
                          $$i > -1 &&
                            (_vm.showRoomGroupUserInFilmArea = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.showRoomGroupUserInFilmArea = $$c
                      }
                    },
                  },
                }),
                _c("span", [_vm._v(_vm._s(_vm.$t("setting.group.topVideo")))]),
              ]),
            ]),
            !_vm.isRoomMode("group")
              ? _c("div", { staticClass: "room-setting-input-box" }, [
                  _c("label", { staticClass: "room-setting-label" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showRoomGroupUserAutoDivide,
                          expression: "showRoomGroupUserAutoDivide",
                        },
                      ],
                      staticClass: "room-setting-radio",
                      attrs: { type: "checkbox", name: "useChat" },
                      domProps: {
                        checked: Array.isArray(_vm.showRoomGroupUserAutoDivide)
                          ? _vm._i(_vm.showRoomGroupUserAutoDivide, null) > -1
                          : _vm.showRoomGroupUserAutoDivide,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.showRoomGroupUserAutoDivide,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.showRoomGroupUserAutoDivide = $$a.concat([
                                  $$v,
                                ]))
                            } else {
                              $$i > -1 &&
                                (_vm.showRoomGroupUserAutoDivide = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.showRoomGroupUserAutoDivide = $$c
                          }
                        },
                      },
                    }),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("setting.group.random"))),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "room-setting-group-btn-box" },
            [
              !_vm.isRoomMode("group")
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "room-group-setting-button start",
                        on: { click: _vm.onStartRoomGroupDiscussion },
                      },
                      [_vm._v(_vm._s(_vm.$t("setting.group.start")))]
                    ),
                  ]
                : [
                    _c(
                      "button",
                      {
                        staticClass: "room-group-setting-button edit",
                        on: { click: _vm.onChangeRoomGroupDiscussion },
                      },
                      [_vm._v(_vm._s(_vm.$t("group.setting.change")))]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "room-group-setting-button end",
                        on: { click: _vm.onEndRoomGroupDiscussion },
                      },
                      [_vm._v(_vm._s(_vm.$t("group.setting.quit")))]
                    ),
                  ],
            ],
            2
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }